import { render, staticRenderFns } from "./profile-avatar.vue?vue&type=template&id=76efb0fd"
import script from "./profile-avatar.vue?vue&type=script&lang=js"
export * from "./profile-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports